/* ----------------------------------------------------------------------------------------------
   MS CASE UPGRADE
   ----------------------------------------------------------------------------------------------
   Wholesale case upgrade nudge in the cart drawer: "order by the case and pay less per bag".
   The wholesale twin of the subscription upgrade bar in ms-gift-ladder.js, and it borrows that
   file's safety rules deliberately.

   THE OFFER
   Only ever ONE button, because a cart drawer crowded with offers is the thing we are avoiding.
   It is the smallest case that gives them BOTH:
     - strictly more bags than they already hold (qty x bags per variant), so an upgrade can
       never take product away from them, and
     - a strictly lower price per bag.
   If no case clears both bars (they are already on the 10 case, or the maths does not favour
   them) nothing is shown at all. We never invent a saving.

   Bags come from the SKU suffix (-2PK, -5PK, -10PK, none = 1), not the variant title: titles are
   display copy and get rewritten, SKUs do not.

   SUBSCRIPTIONS STAY SUBSCRIPTIONS (Thomas, 2026-10-12). A line on a selling plan compares and
   upgrades on that plan's prices and the new case is added with the SAME selling_plan; a
   one-time line upgrades to a one-time case. Cases without that plan are never offered.

   THE SWAP
   ADD FIRST, REMOVE SECOND, the same ordering ms-gift-ladder.js uses. If the add fails the bag is
   untouched; if the remove fails they briefly see both lines, which is recoverable. The one
   failure we never allow is a customer losing the line they already paid attention to. The old
   line is re-located by variant id at click time, so a stale key from an earlier paint can never
   remove the wrong line.

   While an upgrade is on screen the wholesale recommendation shelf is hidden, so a cafe sees one
   clear offer rather than two competing ones.
---------------------------------------------------------------------------------------------- */
(function () {
  'use strict';

  function config() {
    var el = document.getElementById('ms-case-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function bagsOf(sku) {
    var m = /-(\d+)PK$/i.exec(sku || '');
    return m ? parseInt(m[1], 10) : 1;
  }

  function money(cents) {
    var whole = cents % 100 === 0;
    return (
      '$' +
      (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2
      })
    );
  }

  /* Per-bag figures are rounded only for display. The comparison below uses exact cents. */
  function perBag(cents, bags) {
    return cents / bags;
  }

  function bestOffer(data) {
    if (!data || !data.lines || !data.lines.length) return null;

    var best = null;

    data.lines.forEach(function (line) {
      var ladder = (line.ladder || [])
        .filter(function (v) {
          return v.available;
        })
        .filter(function (v) {
          /* A subscription line may only move to a case that carries the same plan. Never
             silently turn a subscription into a one-time order. */
          return !line.plan || typeof v.plan_cents === 'number';
        })
        .map(function (v) {
          return { id: v.id, bags: bagsOf(v.sku), cents: line.plan ? v.plan_cents : v.cents };
        })
        .sort(function (a, b) {
          return a.bags - b.bags;
        });

      var current = null;
      ladder.forEach(function (v) {
        if (v.id === line.variant) current = v;
      });
      if (!current) return;

      var haveBags = current.bags * (line.qty || 1);
      var havePerBag = perBag(current.cents, current.bags);

      var next = null;
      ladder.forEach(function (v) {
        if (v.bags <= haveBags) return; /* never fewer bags than they already hold */
        if (perBag(v.cents, v.bags) >= havePerBag) return; /* must genuinely be cheaper per bag */
        if (!next || v.bags < next.bags) next = v;
      });
      if (!next) return;

      var candidate = {
        line: line,
        from: current,
        to: next,
        haveBags: haveBags,
        perFrom: havePerBag,
        perTo: perBag(next.cents, next.bags)
      };

      /* With more than one wholesale line, pitch the biggest order. */
      if (!best || candidate.to.cents > best.to.cents) best = candidate;
    });

    return best;
  }

  function label(offer) {
    var bags = offer.to.bags;
    return {
      bold: 'Case of ' + bags + ': ' + money(Math.round(offer.perTo)) + ' a bag instead of ' + money(Math.round(offer.perFrom)),
      sub: bags + ' x 1kg for ' + money(offer.to.cents)
    };
  }

  function wholesaleShelf() {
    return document.querySelector('[data-ms-recs][data-ms-recs-mode="wholesale"]');
  }

  function paint() {
    var shells = document.querySelectorAll('[data-mscase-upgrade]');
    if (!shells.length) return;

    var offer = bestOffer(config());
    var shelf = wholesaleShelf();

    if (!offer) {
      shells.forEach(function (s) {
        s.hidden = true;
        var w = s.querySelector('[data-mscase-upgrade-buttons]');
        if (w) w.innerHTML = '';
      });
      /* Release the shelf and let ms-cart-recommendations.js own its own visibility again. */
      if (shelf) shelf.removeAttribute('data-ms-recs-suppressed');
      return;
    }

    var copy = label(offer);

    shells.forEach(function (shell) {
      var wrap = shell.querySelector('[data-mscase-upgrade-buttons]');
      if (!wrap) return;
      wrap.innerHTML = '';

      /* Someone holding a single bag is invited to order by the case; someone already on a
         case is invited to a bigger one. */
      var title = shell.querySelector('[data-mscase-upgrade-title]');
      if (title) {
        title.textContent = offer.haveBags > 1
          ? 'Upgrade to a bigger case and pay less per bag'
          : 'Order by the case and pay less per bag';
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'msgift-upgrade__btn';
      btn.setAttribute('data-case-bags', offer.to.bags);

      var text = document.createElement('span');
      text.className = 'msgift-upgrade__text';
      var strong = document.createElement('strong');
      strong.textContent = copy.bold;
      var sub = document.createElement('span');
      sub.textContent = copy.sub;
      text.appendChild(strong);
      text.appendChild(sub);
      btn.appendChild(text);

      btn.addEventListener('click', function () {
        runUpgrade(offer, btn);
      });
      wrap.appendChild(btn);
      shell.hidden = false;
    });

    /* One offer at a time: the cross-sell shelf stands down while an upgrade is showing.
       The attribute is the handshake, not the `hidden` flag on its own. Both scripts race on
       load (this one paints on DOMContentLoaded, the shelf unhides whenever its fetch lands)
       and without an explicit marker whichever finished last would win, which showed up on live
       as the shelf reappearing beside the upgrade bar. ms-cart-recommendations.js reads this
       and refuses to unhide while it is set. */
    if (shelf) {
      shelf.setAttribute('data-ms-recs-suppressed', '');
      shelf.hidden = true;
    }
  }

  /* The replacement line keeps whatever the old line had: its selling plan, or none. */
  function planItem(offer) {
    var item = { id: offer.to.id, quantity: 1 };
    if (offer.line.plan) item.selling_plan = offer.line.plan;
    return item;
  }

  function samePlan(cartItem, line) {
    var planId = cartItem.selling_plan_allocation ? cartItem.selling_plan_allocation.selling_plan.id : null;
    return (planId || null) === (line.plan || null);
  }

  function runUpgrade(offer, btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [planItem(offer)] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('case upgrade add failed');
        return fetch('/cart.js').then(function (x) {
          return x.json();
        });
      })
      .then(function (cart) {
        /* Re-locate the line being replaced by variant id NOW, not by the key captured at
           paint time, which may be stale after any other cart change. */
        var old = null;
        cart.items.forEach(function (i) {
          if (old) return;
          if (i.variant_id === offer.from.id && samePlan(i, offer.line)) old = i;
        });
        if (!old) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: old.key, quantity: 0 })
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        if (window.console && console.warn) console.warn('ms-case-upgrade:', err);
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('is-busy');
      });
  }

  /* The drawer redraws itself from the server on cart:refresh, which rebuilds the config block.
     Re-read it after that lands; no completion event exists, so mirror ms-cart-recommendations.js
     and check twice. */
  function paintSoon() {
    [300, 900].forEach(function (ms) {
      setTimeout(paint, ms);
    });
  }

  document.addEventListener('cart:refresh', paintSoon);
  document.addEventListener('cart:change', paintSoon);

  /* Paint on the retry schedule at load too, not just once: the shelf's own fetch can land
     after our first pass, so we need a second word. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      paint();
      paintSoon();
    });
  } else {
    paint();
    paintSoon();
  }
})();
